import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-error',
    templateUrl: './app.error.component.html',
    styleUrls: ['./app.error.component.scss'],
    standalone: true,
    imports: [ButtonModule, RouterLink]
})
export class AppErrorComponent {

}
